module.exports = __webpack_public_path__ + "static/media/load-white.4ce87d31.svg";